import useSWR from 'swr';
import PublicSwitchEventGray, { Body } from '@quickService/PublicSwitchEventGray';

/**
 * 查询是否开放 Lobby 入口  lobby_downgrade2register_switch
 */
export function useEventGray(params: Body): {
  lobbySwitch: boolean;
} {
  const { data } = useSWR(
    params,
    (params: Body) => {
      if (!params.host_id && !params.event_id) {
        return Promise.resolve(false);
      }
      return PublicSwitchEventGray(params)
        .then((res) => {
          if (res.code === 0 && 'gray_switch' in res.data) {
            const graySwitch = res.data.gray_switch || [];
            return graySwitch.includes('lobby_downgrade2register_switch');
          }
          return false;
        })
        .catch(() => false);
    },
    {
      revalidateOnMount: true, // 在 mount 时请求
      revalidateOnFocus: false,
    },
  );

  return {
    lobbySwitch: data === false,
  };
}
